// extracted by css-extract-rspack-plugin
export default {"cls1":"CiterightLanding-cls1_6J2","cls2":"CiterightLanding-cls2_SgX CiterightLanding-cls1_6J2"};